import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { ContactPhone, ContactPhoneDto, ContactPhoneType } from '../types/contact-phone';
import { tap } from 'rxjs/operators';
// import { PHONE_TYPES } from '../types/contact-phone-types';

@Injectable()
export class ContactService {
  public onContactAddedSubject: Subject<ContactPhone> = new Subject<ContactPhone>();
  public contactsSubject: BehaviorSubject<ContactPhone[]> = new BehaviorSubject<ContactPhone[]>([]);
  public phoneTypesSubject: BehaviorSubject<ContactPhoneType[]> = new BehaviorSubject<ContactPhoneType[]>([]);
  public dialogEmmited: Subject<boolean> = new Subject<boolean>();
  public saveRequested: Subject<void> = new Subject<void>();
  
  constructor(public request: RequestService) {}

  getContactList(clientId: number | string): Observable<ContactPhone[]> {
    return this.request.get(['users', clientId, 'contacts']).pipe(
      tap((contacts: ContactPhone[]) => this.contactsSubject.next(contacts))
    );
  }

  getContactTypes(): Observable<ContactPhoneType[]> {
    return this.request.get(['contact-types']).pipe(
      tap((phoneTypes: ContactPhoneType[]) => this.phoneTypesSubject.next(phoneTypes))
    );
  }

  createContact(clientId: number | string, contactsDto: ContactPhoneDto): Observable<ContactPhone> {
    return this.request.post(['users', clientId, 'contacts'], {
      body: contactsDto
    });
  }

  editContact(clientId: number | string, id: number | string, contactsDto: ContactPhoneDto): Observable<ContactPhone> {
    return this.request.post(['users', clientId, 'contacts', id], {
      body: contactsDto
    });
  }

  deleteContact(clientId: number | string, id: number | string): Observable<any> {
    return this.request.delete(['users', clientId, 'contacts', id]);
  }
}
